// src/Pages/Juegos/Tragamonedas/Tragamonedas.jsx

//Dependencias
import { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

//Componentes
import BannerFichas from '../../../components/BannerFichas/BannerFichas';
import Navbar from '../../../components/Navbar/Navbar';
import SessionBar from '../../../components/SessionBar/SessionBar';
import Footer from '../../../components/Footer/Footer';
import PhaserTragamonedas from '../../../components/Phaser/PhaserTragamonedas/PhaserTragamonedas';
import BotonGrandeDinamico from '../../../components/Botones/BotonGrandeDinamico/BotonGrandeDinamico';

//Funciones
import { fetchUserData } from '../../../utils/api';
import { useTranslation } from 'react-i18next';

const Tragamonedas = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [userData, setUserData] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const gameContainerRef = useRef(null);

  useEffect(() => {
    fetchUserData(navigate, setUserData);
  }, [navigate]);

  useEffect(() => {
    const onFsChange = () => {
      const isFs = !!document.fullscreenElement;
      setIsFullscreen(isFs);
      if (!isFs) {
        try {
          window.screen.orientation?.unlock?.();
        } catch {}
        // Recargar la página para restaurar el layout correctamente
        setTimeout(() => window.location.reload(), 300);
      }
    };
    document.addEventListener('fullscreenchange', onFsChange);
    return () => document.removeEventListener('fullscreenchange', onFsChange);
  }, []);

  const toggleFullscreen = useCallback(async () => {
    try {
      if (!document.fullscreenElement) {
        await gameContainerRef.current?.requestFullscreen();
        try {
          await window.screen.orientation?.lock?.('landscape');
        } catch {}
      } else {
        await document.exitFullscreen();
      }
    } catch {}
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <BannerFichas />
      <div className="bg-gradient-to-b from-slate-950 to-violet-950 flex-grow pb-3 md:pb-10">
        <Navbar />
        <SessionBar />

        <div className="flex flex-col flex-grow items-center justify-center text-center py-3 md:py-10">
          <h1 className="text-2xl text-yellow-500 font-bold mb-4 md:mb-8">
            {t('gamesList.slots')}
          </h1>
          <div className="relative w-full max-w-4xl mx-auto">
            <div
              ref={gameContainerRef}
              className={`bg-bgContenedorOscuro rounded-lg border-4 border-borderContenedorOscuro shadow-shadowContenedorOscuro shadow-[0_5px_15px_0_rgba(148,0,211,0.5)] w-full aspect-video ${
                isFullscreen ? 'flex items-center justify-center bg-black' : ''
              }`}
            >
              <PhaserTragamonedas />
            </div>
            <div className="md:hidden mt-4">
              <BotonGrandeDinamico
                texto={
                  <>
                    <svg
                      className="w-5 h-5"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      {isFullscreen ? (
                        <>
                          <path d="M8 3v3a2 2 0 0 1-2 2H3" />
                          <path d="M21 8h-3a2 2 0 0 1-2-2V3" />
                          <path d="M3 16h3a2 2 0 0 1 2 2v3" />
                          <path d="M16 21v-3a2 2 0 0 1 2-2h3" />
                        </>
                      ) : (
                        <>
                          <path d="M3 3h5v2H5v3H3z" />
                          <path d="M16 3h5v5h-2V5h-3z" />
                          <path d="M21 16v5h-5v-2h3v-3z" />
                          <path d="M3 16v5h5v-2H5v-3z" />
                        </>
                      )}
                    </svg>
                    {isFullscreen ? 'Salir' : 'Pantalla completa'}
                  </>
                }
                bgColor="pink"
                funcion={toggleFullscreen}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Tragamonedas;
